<template>
  <div>
    <el-form :inline="true">
      <!-- <el-form-item>
        <el-input v-model="word" placeholder="请输入昵称进行搜索" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="getAdminList()">搜索</el-button>
      </el-form-item> -->
      <el-form-item style="float: right;">
        <el-button type="primary" style="float: right;" @click="addAdminClick">新建菜单</el-button>
      </el-form-item>
    </el-form>
    <!-- v-if="operations.includes('新增管理员')" -->
    <div class="table-wrap">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="menu_name" label="菜单名称" align="center">
        </el-table-column>
        <el-table-column prop="menu_url" label="菜单url" align="center">
        </el-table-column>
        <el-table-column prop="level" label="菜单等级" align="center">
        </el-table-column>
        <el-table-column prop="p_menu_url" label="上级菜单" align="center">
        </el-table-column>
        <el-table-column label="操作" align="center" width="160">
          <template slot-scope="scope">
            <div class="operation-wrap">
              <span class="operation-item" @click="editAdminClick(scope.row)">编辑</span>
              <!-- v-if="operations.includes('编辑管理员')" -->
              <span class="danger operation-item" @click="deleteAdminClick(scope.row)">删除</span>
              <!-- v-if="operations.includes('删除管理员')" -->
            </div>
          </template>
        </el-table-column>
      </el-table>
      <common-pagination :total="total" :page_size="page_size" @size-change="handelPagesizeChange"
                         @page-change="handlePageChange"></common-pagination>
    </div>
    <common-dialog :title="dialogTitle" :dialogVisible="dialogVisible" @cancel="dialogCancelClick"
                   @confirm="dialogConfirmClick" @dialog-close="dialogClose">
      <div class="dialog-body-wrap">
        <div v-if="dialogType ==='delete'">
          是否删除该菜单？
        </div>
      </div>
    </common-dialog>
    <menu-edit-dialog :uuid="selectForm" :dialogProp="editdialogVisible" @input="closeDialog"
                      @confirmClick="refreshData">
    </menu-edit-dialog>
  </div>
</template>

<script>
import CommonPagination from "@/components/CommonPagination";
import CommonDialog from "@/components/CommonDialog";
import MenuEditDialog from "./components/menuEditdialog";
import {
  LimitsList,
  getMenuList,
  identityOf,
  addAdminUser,
  editAuthUser,
  delMenu
} from "@/api/auth";
import {
  mapState
} from "vuex";
import operations from "@/mixins/operations";

export default {
  mixins: [operations],
  data() {
    return {
      tableData: [],
      page_index: "1", //第几页
      page_size: "50",
      total: 100, //总条数
      word: "",
      dialogVisible: false,
      editdialogVisible: false,
      dialogTitle: "",
      dialogType: "",
      handle_row: {},
      selectForm: {},
      three_rules: [],
      keyword_search: ""
    };
  },
  components: {
    CommonPagination,
    CommonDialog,
    MenuEditDialog
  },
  computed: {
    ...mapState(["operationList"])
  },
  mounted() {
    this.getAdminList();
  },
  methods: {
    async getAdminList() {
      let postData = {
        page_size: this.page_size,
        page_index: this.page_index,
        keyword_search: this.word
      };
      const {
        status,
        data
      } = await getMenuList(postData);
      if (status !== 200) return;

      this.tableData = data.result.data;
      this.total = data.result.total;
    },
    addAdminClick() {
      this.selectForm = {};
      this.editdialogVisible = true;
    },
    editAdminClick(row) {
      this.selectForm = row;
      this.editdialogVisible = true;

    },
    closeDialog(row) {
      this.editdialogVisible = row;
    },
    refreshData() {
      this.getAdminList();
    },
    deleteAdminClick(row) {
      this.form = JSON.parse(JSON.stringify(row));
      this.dialogVisible = true;
      this.dialogType = "delete";
      this.dialogTitle = "删除菜单";
    },
    handelPagesizeChange(size) {
      this.page_size = size;
      this.getAdminList();
    },
    handlePageChange(page) {
      this.page_index = page;
      this.getAdminList();
    },
    handlerSerial(index) {
      return (this.page_index - 1) * this.page_size + (index + 1);
    },
    dialogCancelClick() {
      this.dialogVisible = false;
    },
    async dialogConfirmClick() {
      if (this.dialogType === "delete") {
        const {
          status
        } = await delMenu({
          menu_id: this.form.menu_id
        });
        if (status === 200) {
          this.dialogVisible = false;
          return;
        }
      }
    },
    dialogClose() {
      this.dialogVisible = false;
      this.checked = false;
      this.form = {};
      this.getAdminList();
    },
    handleThreeRules() {
      //处理三级权限
      let second_menu_name = this.$route.meta[1].name;
      this.operationList.forEach(item => {
        if (second_menu_name === item.name) {
          this.three_rules = item.operations;
        }
      });
      this.three_rules.forEach(item => {
        switch (true) {
          case item.menu_name.indexOf("添加") !== -1:
            this.auth_control.have_add_auth = true;
            break;
          case item.menu_name.indexOf("删除") !== -1:
            this.auth_control.have_delete_auth = true;
            break;
          case item.menu_name.indexOf("编辑") !== -1:
            this.auth_control.have_edit_auth = true;
            break;
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
@import "~@/assets/styles/variables.less";
@import "~@/assets/styles/mixins.less";

.addBtn {
  float: right;
  margin-bottom: 30px;
  .addBtn();
}

.input {
  width: 300px;
  margin-right: 30px;
}

.table-wrap {
  .table-wrap();
}
</style>
